import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../Styles';

const SUB_HEADER_BAR_BAR_STYLE = css`
  label: SUB_HEADER_BAR_BAR_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing1}px;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  background: ${COLORS2.alwaysDark.background.light};
  padding: 0 ${LAYOUT2.spacing2}px;
  height: ${LAYOUT2.spacing6}px;
  min-height: ${LAYOUT2.spacing6}px;
`;

const SUB_HEADER_BAR_BAR_NAME_STYLE = css`
  label: SUB_HEADER_BAR_BAR_NAME_STYLE;
  display: flex;
  flex-direction: row;
  gap: ${LAYOUT2.spacing1}px;
  ${TYPOGRAPHY2.xLarge}
  color: ${COLORS2.alwaysDark.text.white};
  flex-grow: 1;
`;

const TITLE_AND_SUB_TITLE_STYLE = css`
  label: TITLE_AND_SUB_TITLE_STYLE;
  display: flex;
  align-items: flex-end;
  gap: ${LAYOUT2.spacing1}px;
`;

const SUB_HEADER_BAR_BAR_SUB_TITLE_STYLE = css`
  label: SUB_HEADER_BAR_BAR_SUB_TITLE_STYLE;
  ${TYPOGRAPHY2.medium}
  color: ${COLORS2.alwaysDark.text.darkGray};
`;

const SUB_HEADER_BAR_BAR_LABEL_STYLE = css`
  label: SUB_HEADER_BAR_BAR_LABEL_STYLE;
  ${TYPOGRAPHY2.medium}
  color: ${COLORS2.alwaysDark.text.white};
  padding-bottom: 1px;
`;

const SUB_HEADER_BAR_BAR_VALUE_STYLE = css`
  label: SUB_HEADER_BAR_BAR_VALUE_STYLE;
  ${TYPOGRAPHY2.largeBold}
  color: ${COLORS2.alwaysDark.text.green};
`;

const SUB_HEADER_BAR_BAR_UNIT_STYLE = css`
  label: SUB_HEADER_BAR_BAR_UNIT_STYLE;
  ${TYPOGRAPHY2.small}
  color: ${COLORS2.alwaysDark.text.lightGray};
`;

const SUB_HEADER_BAR_BAR_DATA_CONTAINER_STYLE = css`
  label: SUB_HEADER_BAR_BAR_DATA_CONTAINER_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing * .5}px;
  align-items: flex-end;
`;

const TITLE_BAR_BUTTONS_STYLE = css`
  label: TITLE_BAR_BUTTONS_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing1}px;
  align-items: center;
`;

const SUB_HEADER_BAR_BAR_FLUSH_BUTTONS_STYLE = css`
  label: SUB_HEADER_BAR_BAR_FLUSH_BUTTONS_STYLE;
  padding-right: 0;
`;

const SUB_HEADER_BAR_BAR_NAME_ICONS_STYLE = css`
  label: SUB_HEADER_BAR_BAR_NAME_ICONS_STYLE;
  display: flex;
  gap: ${LAYOUT2.spacing1}px;
  align-items: center;
`;
export const PageSubHeaderBar = ({ title, subTitle, titleIcons, labeledValues, buttons, flushButtons = false }: {
  title: string;
  subTitle?: string;
  titleIcons?: ReactNode[];
  labeledValues?: { label: string; value: string; unit?: string }[];
  buttons?: ReactNode[];
  flushButtons?: boolean;
}) => (
  <div css={[SUB_HEADER_BAR_BAR_STYLE, flushButtons ? SUB_HEADER_BAR_BAR_FLUSH_BUTTONS_STYLE : undefined]}>
    <div css={SUB_HEADER_BAR_BAR_NAME_STYLE}>
      <div css={TITLE_AND_SUB_TITLE_STYLE}>{title}{subTitle && <div css={SUB_HEADER_BAR_BAR_SUB_TITLE_STYLE}>{subTitle}</div>}</div>
      {titleIcons && <div css={SUB_HEADER_BAR_BAR_NAME_ICONS_STYLE}>{titleIcons}</div>}
    </div>
    {labeledValues?.map((value, index) => (
      <div key={index} css={SUB_HEADER_BAR_BAR_DATA_CONTAINER_STYLE}>
        <div css={SUB_HEADER_BAR_BAR_LABEL_STYLE}>{value.label}:</div>
        <div css={SUB_HEADER_BAR_BAR_VALUE_STYLE}>{value.value}</div>
        {value.unit && <div css={SUB_HEADER_BAR_BAR_UNIT_STYLE}>{value.unit}</div>}
      </div>
    ))}
    <div css={TITLE_BAR_BUTTONS_STYLE}>
      {buttons}
    </div>
  </div>
);
